import type { POSLinea } from './types';

export const MSG_CLIENTE_BLOQUEADO_POR_MASTER =
  'Hay renglones con seguimiento de ventas de otro cliente. Quitá esas líneas para cambiar el cliente.';

export const lineaTieneMaster = (l: POSLinea): boolean => {
  const nfm = Number(l.nroFormularioMaster);
  const nim = Number(l.nroItemMaster);
  return Number.isFinite(nfm) && nfm > 0 && Number.isFinite(nim) && nim > 0;
};

/** Bloquea cambiar/quitar cliente si hay ítems master de otro nroCliente. */
export const lineasBloqueanEdicionCliente = (
  lineas: POSLinea[],
  nroClienteActual: number,
): boolean => {
  const nroCli = Number(nroClienteActual) || 0;
  if (nroCli <= 0) return false;
  return lineas.some((l) => {
    if (!lineaTieneMaster(l)) return false;
    const nm = Number(l.nroClienteMaster);
    return nm > 0 && nm !== nroCli;
  });
};

export const masterFieldsParaLinea = (
  nroFormularioMaster: number,
  nroItemMaster: number,
  nroClienteMaster: number,
): Pick<POSLinea, 'nroFormularioMaster' | 'nroItemMaster' | 'nroClienteMaster'> => ({
  nroFormularioMaster,
  nroItemMaster,
  nroClienteMaster: Number(nroClienteMaster) || 0,
});
